module.exports = __webpack_public_path__ + "img/xxx.f3f3ecfc.png";